import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/facebook-color.svg")